module.exports = __webpack_public_path__ + "img/logout.1f16ce6c.svg";